import { render, staticRenderFns } from "./ServicesTable.vue?vue&type=template&id=638db848&"
import script from "./ServicesTable.vue?vue&type=script&lang=js&"
export * from "./ServicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports